import * as React from "react";
import type { SVGProps } from "react";
const SvgLogoWhatsapp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M14 15.98h1l-.01-.01c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5h-1c-.56 0-1.06.32-1.31.78a4.003 4.003 0 0 1-2.46-2.46c.47-.25.78-.74.78-1.31v-1c0-.83-.67-1.5-1.5-1.5S8 8.15 8 8.98v1c0 3.31 2.69 6 6 6Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.92 21.12c1.298.59 2.697.88 4.085.88H12h.01-.005a9.996 9.996 0 0 0 5.755-1.83c4.51-3.17 5.59-9.42 2.42-13.93S10.76.64 6.25 3.82a9.948 9.948 0 0 0-4.1 6.47c-.42 2.44.06 4.9 1.37 6.99l-1.43 3.3c-.15.34-.1.74.13 1.02s.6.43.96.36l4.74-.84Zm.57-1.94a.976.976 0 0 0-.44-.1l-.01-.02c-.06 0-.12.01-.18.02l-3.21.57.91-2.09c.14-.32.1-.68-.1-.97a7.917 7.917 0 0 1-1.34-5.97c.37-2.1 1.53-3.94 3.28-5.17a7.907 7.907 0 0 1 5.97-1.34c2.1.37 3.94 1.53 5.17 3.28C21.08 11 20.22 16 16.61 18.54a7.98 7.98 0 0 1-8.12.64Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgLogoWhatsapp;
